import { useQuery } from '@tanstack/react-query';

import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';
import { MovieDto } from '@cineamo/api/models/movie/v2/MovieDto.types';

import { getMovieById } from '@cineamo/api/resources/movie/movie-v2-api';

export function useMovie(
    movieId: MovieDto['id'] | undefined,
    locale?: string,
    cinemaId?: CinemaDto['id'],
    include?: string
) {
    const { data, isLoading } = useQuery<MovieDto | null>({
        queryKey: ['movie', movieId, locale, cinemaId, include],
        queryFn: async () => {
            if (!movieId) {
                return null;
            }
            return getMovieById(movieId, { locale, cinemaId, include });
        },
        enabled: !!movieId
    });
    return { movie: data, isLoading };
}
